// 导肮菜单
const NAV_MENU = [
  {
    title: '首页',
    router: '/index'
  },
  // {
  //     title: '产品',
  //     router: '/product',
  //     subMenu: [
  //         {
  //             id: 0,
  //             title: '机构知识库',
  //         },
  //         {
  //             id: 1,
  //             title: '选学科',
  //         },
  //         {
  //             id: 2,
  //             title: '学达网',
  //         },
  //         {
  //             id: 3,
  //             title: '有人科汇',
  //         }
  //     ]
  // },
  {
    title: '服务',
    router: '/services'
  },
  {
    title: '资讯',
    router: '/news'
  },
  {
    title: '关于',
    router: '/about'
  }
]

// banner
const BANNER_LIST = [
  {
    name: 'banner1',
    title: '我们挖掘数据，数据创造价值',
    subTitle: '',
    img: '/static/img/banner_img_01.png'
  },
  {
    name: 'banner2',
    title: '我们分析数据，数据驱动服务',
    subTitle: '',
    img: '/static/img/banner_img_02.png'
  },
  {
    name: 'banner3',
    title: '我们运用数据，数据实现智慧',
    subTitle: '',
    img: '/static/img/banner_img_03.png'
  }
]

// 栏目列表
const COLUMN_LIST = [
  {
    title: '数据智能服务',
    icon: 'icon-keji'
  },
  {
    title: '业务应用开发',
    icon: 'icon-yewutubiaopinpaixianshiqianggou'
  },
  {
    title: '信息推荐引擎',
    icon: 'icon-tuijianzhiwei'
  },
  {
    title: '知识图谱网络',
    icon: 'icon-xuexifenxi'
  }
]

// 公司优势
const ADVANTAGE_LIST = [
  {
    title: '数据采集',
    desc: '专注学术科研数据，更懂你需要什么数据',
    icon: 'icon-shuju'
  },
  {
    title: '数据管理',
    desc: '用大数据保驾护航，让知识关联细致入微',
    icon: 'icon-shuju2'
  },
  {
    title: '数据分析',
    desc: '灵活支持各种形式，完成报告更轻松简单',
    icon: 'icon-shuju1'
  },
  {
    title: '智能推荐',
    desc: '机器学习算法驱动，个性化资讯精准推送',
    icon: 'icon-Intelligent'
  },
  {
    title: '数据挖掘',
    desc: '海量数据发现提取，情报预测更加精确',
    icon: 'icon-yemian'
  },
  {
    title: '数据交互',
    desc: '实时数据动态呈现，多种场景联合交互',
    icon: 'icon-kuaduanjiaohu'
  }
]

// 首页-产品
const PRODUCT_LIST = [
  {
    title: '知识智能',
    subTitle: '互联网应用架构',
    titleEn: 'KNOWLEDGE INTELLIGENCE',
    desc: '提供知识管理、成果展示、技术转化的自动化处理平台，让高校、机构、企业开启知识管理的精益之道。',
    icon: '/static/img/icon/icon_jgzsk.png',
    iconColor: '/static/img/icon/icon_color_jgzsk.png',
    bgUrl: '/static/img/tab_bg_01.png',
    img: '/static/img/tab_jgzsk.png',
    text: '我们为高校、机构、企业提供定制化知识库建设，配以高效便携的移动端应用，提供知识管理、成果展示、技术转化的自动化处理平台，让高校、机构、企业开启知识管理的精益之道，给用户带来有趣智能的知识工具。'
  },
  {
    title: '智慧科研',
    subTitle: '互联网应用架构',
    titleEn: 'SCIENTIFIC INTELLIGENCE',
    desc: '建设可持续发展的科研数据观测环境，让科研管理更轻松科学。',
    icon: '/static/img/icon/icon_xxk.png',
    iconColor: '/static/img/icon/icon_color_yrkh.png',
    bgUrl: '/static/img/tab_bg_02.png',
    img: '/static/img/tab_jgzsk.png',
    text: '我们为高校、机构、企业提供定制化学术科研数据的观测平台，拥有多维度、个性化指标体系，科研数据及时观测，建设可持续发展的科研数据观测环境，让科研管理更轻松科学。'
  },
  {
    title: '智慧交通',
    subTitle: '互联网应用架构',
    titleEn: 'TRANSPORTATION INTELLIGENCE',
    desc: '运用自身优势产品，利用物联网、云计算、大数据、移动互联等技术，汇聚数据，提供实时展示，赋能互联网+交通。',
    icon: '/static/img/icon/icon_xdw.png',
    iconColor: '/static/img/icon/icon_color_xdw.png',
    bgUrl: '/static/img/tab_bg_03.png',
    img: '/static/img/tab_jgzsk.png',
    text: '我们为机场、航运提供定制化数据分析、展示、预警平台，随时监测运行状态，智能保障业务平台。运用自身优势产品，利用物联网、云计算、大数据、移动互联等技术，汇聚数据，提供实时展示，赋能互联网+交通。'
  },
  {
    title: '智慧教育',
    subTitle: '互联网应用架构',
    titleEn: 'SMART EDUCATION',
    desc: '有人科汇，实现从产品研发到最终发布的自动化流程，让企业开启产品研发的精益之道。',
    icon: '/static/img/icon/icon_yrkh.png',
    iconColor: '/static/img/icon/icon_color_yrkh.png',
    bgUrl: '/static/img/tab_bg_04.png',
    img: '/static/img/tab_jgzsk.png',
    text: '我们为学校、教师、家长、孩子提供轻松、有趣的教学环境，根据角色模拟不同场景，通过大数据分析，实现个性化智能教学。'
  },
  {
    title: '数字政务',
    subTitle: '互联网应用架构',
    titleEn: 'DIGITAL GOVERNMENT',
    desc: '我们为政府部门提供云政务解决方案，借助我们的的数据处理能力、丰富的技术基础，实现了互联网与地方政务服务的深度融合',
    icon: '/static/img/icon/icon_yrkh.png',
    iconColor: '/static/img/icon/icon_color_yrkh.png',
    bgUrl: '/static/img/tab_bg_04.png',
    img: '/static/img/tab_jgzsk.png',
    text: '我们为政府机构提供定制化的大数据监测平台，对安全安防、社情民意、宏观经济、舆情舆论提供专业的大数据监测分析方案，借助我们的的数据处理能力、丰富的技术基础，实现了互联网与地方政务服务的深度融合。'
  },
  {
    title: '智慧金融',
    subTitle: '互联网应用架构',
    titleEn: 'SMART FINANCE',
    desc: '我们用红包问答游戏建立去中心化的社交网络，用区块链技术结合实际场景实现数字价值。',
    icon: '/static/img/icon/icon_yrkh.png',
    iconColor: '/static/img/icon/icon_color_yrkh.png',
    bgUrl: '/static/img/tab_bg_04.png',
    img: '/static/img/tab_jgzsk.png',
    text: '我们借助先进的分布式存储技术、成熟的云计算能力、强大的平台优势和丰富的用户基础，用红包问答游戏建立去中心化的社交网络，用区块链技术结合实际场景实现数字价值。'
  }
]

// 首页-产品-tab
const PRODUCT_TAB_LIST = [
  {
    title: '机构知识库',
    desc: '提供知识管理、成果展示、人才评估的智库平台，让高校、机构、企业开启知识管理的精益之道',
    img: '/static/img/tab_jgzsk.png'
  },
  {
    title: '学术分析平台',
    desc: '建设可持续发展的科研数据观测环境，让科研管理更轻松科学，科研报告一键可达',
    img: '/static/img/tab_xsfxpt.png'
  },
  {
    title: '有人科汇',
    desc: '利用人工智能+大数据，建立政产学研服务生态圈，为企业提供一站式科技馆家服务，让技术转移、成果转化不再困难',
    img: '/static/img/tab_yrkh.png'
  },
  {
    title: '智能航道系统',
    desc: '利用大数据，结合物联网等技术，对传统模式的航道系统全面升级，通过数据感知、处理、关联、分析、展示等，形成先进的数字航道、智能航道系统',
    img: '/static/img/tab_znhdxt.png'
  },
  {
    title: '航班管理系统',
    desc: '利用大数据技术，航班信息实时获取，保障顺畅运行，为航空公司建立拥有高效机能的智能航班管理',
    img: '/static/img/tab_hbglxt.png'
  }
]

// 产品页-产品详情
const PRODUCT_DETAIL_LIST = [
  {
    title: '机构知识库',
    introduce: '公司先后为湖北省政府办公厅、潜江市政府、武汉市新洲区政府、硚口区政府、武汉理工大学、武汉大学、海航集团、中船重工、湖北烟草、中国科学院、武汉地铁集团等超过二百家政府、企业、教育等行业客户提供过优质的信息化服务。',
    list: [
      {
        title: '精准数据清洗',
        icon: 'icon-shujutubiao',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      },
      {
        title: '复合大数据',
        icon: 'icon-dashuju',
        desc: '海量、高增长率和多样化的信息资产提供数据处理，分析，增值能力'
      },
      {
        title: '云计算服务',
        icon: 'icon-yunjisuan',
        desc: '通过全面环境监控系统、模块化建设、高效的气流组织结构设计等领先方案为客户打造新一代绿色高效'
      },
      {
        title: '管理式网络服务',
        icon: 'icon-fuwu',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      }
    ]
  },
  {
    title: '选学科',
    introduce: '公司先后为湖北省政府办公厅、潜江市政府、武汉市新洲区政府、硚口区政府、武汉大学、海航集团、中船重工、湖北烟草、中国科学院武汉分院、武汉地铁集团等超过二百家政府、企业、教育等行业客户提供过优质的信息化服。',
    list: [
      {
        title: '精准数据清洗',
        icon: 'icon-shujutubiao',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      },
      {
        title: '复合大数据',
        icon: 'icon-dashuju',
        desc: '海量、高增长率和多样化的信息资产提供数据处理，分析，增值能力'
      },
      {
        title: '云计算服务',
        icon: 'icon-yunjisuan',
        desc: '通过全面环境监控系统、模块化建设、高效的气流组织结构设计等领先方案为客户打造新一代绿色高效'
      },
      {
        title: '管理式网络服务',
        icon: 'icon-fuwu',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      }
    ]
  },
  {
    title: '学达网',
    introduce: '公司先后为湖北省政府办公厅、潜江市政府、武汉市新洲区政府、硚口区政府、武汉大学、海航集团、中船重工、湖北烟草、中国科学院武汉分院、武汉地铁集团等超过二百家政府、企业、教育等行业客户提供过优质的信息化服。',
    list: [
      {
        title: '精准数据清洗',
        icon: 'icon-shujutubiao',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      },
      {
        title: '复合大数据',
        icon: 'icon-dashuju',
        desc: '海量、高增长率和多样化的信息资产提供数据处理，分析，增值能力'
      },
      {
        title: '云计算服务',
        icon: 'icon-yunjisuan',
        desc: '通过全面环境监控系统、模块化建设、高效的气流组织结构设计等领先方案为客户打造新一代绿色高效'
      },
      {
        title: '管理式网络服务',
        icon: 'icon-fuwu',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      }
    ]
  },
  {
    title: '有人科汇',
    introduce: '公司先后为湖北省政府办公厅、潜江市政府、武汉市新洲区政府、硚口区政府、武汉大学、海航集团、中船重工、湖北烟草、中国科学院武汉分院、武汉地铁集团等超过二百家政府、企业、教育等行业客户提供过优质的信息化服。',
    list: [
      {
        title: '精准数据清洗',
        icon: 'icon-shujutubiao',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      },
      {
        title: '复合大数据',
        icon: 'icon-dashuju',
        desc: '海量、高增长率和多样化的信息资产提供数据处理，分析，增值能力'
      },
      {
        title: '云计算服务',
        icon: 'icon-yunjisuan',
        desc: '通过全面环境监控系统、模块化建设、高效的气流组织结构设计等领先方案为客户打造新一代绿色高效'
      },
      {
        title: '管理式网络服务',
        icon: 'icon-fuwu',
        desc: '每一个客户传递正确的解决办法，为每个客户争取大的I.T.价值'
      }
    ]
  }
]

// 服务页-服务列表
const SERVICE_LIST = [
  {
    isImg: false,
    title: '数据智能服务',
    text: '多年数据处理经验积累，使我们成为一家大数据智能服务提供商，运用自身数据和科技实力，通过大数据挖掘与分析，为客户进一步发掘数据价值，实现数据智能。'
  },
  {
    isImg: true,
    src: 'static/img/img_service_02.png'
  },
  {
    isImg: true,
    src: 'static/img/img_service_04.png'
  },
  {
    isImg: false,
    title: '业务应用开发',
    text: '凭借经验丰富的开发团队和技术专家，提供定制化应用系统设计、业务开发服务，为客户提供更规范专业的定制化应用系统及解决方案，使应用系统运行更加高效稳定，帮助客户实现业务目标。'
  },
  {
    isImg: false,
    title: '信息推荐引擎',
    text: '发现用户当前或潜在需求，挖掘用户的喜好和习惯，主动向用户推荐其感兴趣或者需要的对象，根据用户画像，定制信息精准推送。'
  },
  {
    isImg: true,
    src: 'static/img/img_service_03.png'
  },
  {
    isImg: true,
    src: 'static/img/img_service_01.png'
  },
  {
    isImg: false,
    title: '知识图谱网络',
    text: '经过多年的发展，已经积累了学术、科研知识图谱等成功案例，合作伙伴覆盖了武汉理工大学、中科院、中船重工、海航集团、湖北烟草、东风汽车、武汉科技局、武汉大学等各机构、企业。我们致力于推进知识图谱在产业界的落地发展，让数据智能更好的支撑商业智能和人工智能服务。'
  }
]

// 服务页-步骤
const STEP_LIST = [
  {
    isDot: false,
    step: 1,
    title: '采集数据',
    desc: '这里有你业务中的多种数据来源，包括了终端（Web、App、H5、软件）的用户行为，后端服务器日志（Log）和业务数据（DataBase）。我们要帮你做的是，根据业务分析需求，高效地采集散落各处的基础数据，永久沉淀企业数据资产。'
  },
  {
    isDot: true
  },
  {
    isDot: false,
    step: 2,
    title: '数据接入与储存',
    desc: '数据接入与储存数据接入与储存数据接入与储存'
  },
  {
    isDot: true
  },
  {
    isDot: false,
    step: 3,
    title: '数据清洗',
    desc: '数据清洗数据清洗数据清洗数据清洗'
  },
  {
    isDot: true
  },
  {
    isDot: false,
    step: 4,
    title: '数据分析',
    desc: '数据分析数据分析数据分析数据分析'
  }
]

// 服务页-案例
const CASE_LIST = [
  {
    img: '/static/img/case/1.png'
  },
  {
    img: '/static/img/case/2.png'
  },
  {
    img: '/static/img/case/3.png'
  },
  {
    img: '/static/img/case/4.png'
  },
  {
    img: '/static/img/case/5.png'
  }
]

export {
  NAV_MENU,
  BANNER_LIST,
  PRODUCT_TAB_LIST,
  COLUMN_LIST,
  ADVANTAGE_LIST,
  PRODUCT_LIST,
  PRODUCT_DETAIL_LIST,
  SERVICE_LIST,
  STEP_LIST,
  CASE_LIST
}



// WEBPACK FOOTER //
// ./src/assets/data/common.js